import { CustomerSVG } from 'components/SVGs/CustomerSVG'
import { FinanceSVG } from 'components/SVGs/FinanceSVG'
import { MarketingSVG } from 'components/SVGs/MarketingSVG'
import { TechnicalSVG } from 'components/SVGs/TechnicalSVG'
import { EVENTS } from 'utils/analytics'

export const PartnersData = [
  {
    title: 'Marketing',
    description: 'The creative engine behind innovative strategies.',
    img: MarketingSVG,
    link: 'https://cokeurl.com/marketing-function',
    event: EVENTS.INNOVATION_CFP_MARKETING_LEARNMORE,
  },
  {
    title: 'Technical, Innovation & Supply Chain',
    description: 'The dynamic nexus driving cutting-edge solutions.',
    img: TechnicalSVG,
    link: 'https://cokeurl.com/tiandsc-function',
    event: EVENTS.INNOVATION_CFP_TECHNICAL_LEARNMORE,
  },
  {
    title: 'Finance',
    description: 'The experts at navigating financial landscapes and strategic initiatives.',
    img: FinanceSVG,
    link: 'https://groups.coca-cola.com/sites/global-finance-and-strategy',
    event: EVENTS.INNOVATION_CFP_FINANCE_LEARNMORE,
  },
  {
    title: 'Customer & Commercial Leadership',
    description: 'Charting the course for our market presence and customer engagement.',
    img: CustomerSVG,
    link: 'https://cokeurl.com/ccc',
    event: EVENTS.INNOVATION_CFP_CUSTOMERCOMMERCIAL_LEARNMORE,
  },
]
